import React from 'react'
import { Link } from 'react-router-dom'
import Page from '../../../assets/images/about/arrow-brudcrumb.svg'
import Cartbg from '../../../assets/images/background/cart-page-bg.jpg'

const PageInear = () => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: `url(${Cartbg})`,
                  }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-8">
                            <div
                                className="page-header-heading animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <h2>Cart</h2>
                                <p className="lead">
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews.
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={Page} alt="icon" />
                        </li>
                        <li>
                            <span>Cart</span>
                        </li>
                    </ul>
                </div>
            </div >

        </>
    )
}

export default PageInear
